import { render, staticRenderFns } from "./Tablero.vue?vue&type=template&id=1f9eb75c"
import script from "./Tablero.vue?vue&type=script&lang=js"
export * from "./Tablero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports